import type { Strategy, StrategyChartPoint } from "./types";

function makeChartData({ length, base, variance }: { length: number; base: number; variance: number }): StrategyChartPoint[] {
  return Array.from({ length }, () => ({ value: base + Math.random() * variance }));
}

const MOCK_CHART_DATA_1 = makeChartData({ length: 20, base: 50, variance: 50 });
const MOCK_CHART_DATA_2 = makeChartData({ length: 20, base: 40, variance: 10 });
const MOCK_CHART_DATA_3 = makeChartData({ length: 20, base: 40, variance: 40 }).map((p) => ({ value: 80 - (p.value - 40) }));

export const STRATEGIES: Strategy[] = [
  {
    id: 1,
    title: "My quantitative strategy",
    score: 8.7,
    profit: "+89,708.00",
    profitValue: 89708,
    version: "Ver 0.1.1",
    status: "online",
    date: "2026.1.4",
    views: 1980,
    chartData: MOCK_CHART_DATA_1,
    chartColor: "#ef4444",
  },
  {
    id: 2,
    title: "My quantitative strategy",
    score: 6.0,
    profit: "0.00",
    profitValue: 0,
    version: "Ver 0.1.1",
    status: "online",
    date: "2026.1.4",
    views: 1980,
    chartData: MOCK_CHART_DATA_2,
    chartColor: "#e5e7eb",
  },
  {
    id: 3,
    title: "My quantitative strategy",
    score: 5.7,
    profit: "-890.00",
    profitValue: -890,
    version: "Ver 0.1.1",
    status: "offline",
    date: "2026.1.4",
    views: 1980,
    chartData: MOCK_CHART_DATA_3,
    chartColor: "#22c55e",
  },
];
